export type DetailsTab = {
  go: (path: string) => void
  close: () => void
}

const BLANK_TARGET = '_blank'

// Must run inside the click so the browser allows it; a blocked tab falls back to this one.
export const openDetailsTab = (fallback: (path: string) => void): DetailsTab => {
  const tab = window.open('', BLANK_TARGET)
  if (!tab) return { go: fallback, close: () => undefined }
  tab.opener = null
  return {
    go: (path) => tab.location.assign(new URL(path, window.location.origin).href),
    close: () => tab.close(),
  }
}
